var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_2494)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(90 36 0)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9434 9.64789H22.4364C22.8912 9.64789 23.2604 9.2787 23.2604 8.82395C23.2604 8.36919 22.8912 8 22.4364 8H16.9434C16.4887 8 16.1195 8.36919 16.1195 8.82395C16.1195 9.2787 16.4887 9.64789 16.9434 9.64789Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6476 12.3944V21.4578C13.6476 22.9743 14.8776 24.2043 16.3941 24.2043H22.9857C24.5023 24.2043 25.7322 22.9743 25.7322 21.4578V12.3944H26.6359C27.0467 12.3944 27.3801 12.0252 27.3801 11.5704C27.3801 11.1157 27.0467 10.7465 26.6359 10.7465H12.7443C12.3334 10.7465 12 11.1157 12 11.5704C12 12.0252 12.3334 12.3944 12.7443 12.3944H13.6479H13.6476ZM17.4927 14.3169V20.9085C17.4927 21.2117 17.7388 21.4578 18.042 21.4578C18.3453 21.4578 18.5913 21.2117 18.5913 20.9085V14.3169C18.5913 14.0137 18.3453 13.7676 18.042 13.7676C17.7388 13.7676 17.4927 14.0137 17.4927 14.3169ZM20.7885 14.3169V20.9085C20.7885 21.2117 21.0346 21.4578 21.3378 21.4578C21.641 21.4578 21.8871 21.2117 21.8871 20.9085V14.3169C21.8871 14.0137 21.641 13.7676 21.3378 13.7676C21.0346 13.7676 20.7885 14.0137 20.7885 14.3169Z",
    fill: "#C7C7C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_2494",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2494"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2494",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.11cc35004f38de64a7c50ad7f430902c.svg";
export { ForwardRef as ReactComponent };